import { render, staticRenderFns } from "./edi-form.vue?vue&type=template&id=7a2a5f46&scoped=true&"
import script from "./edi-form.vue?vue&type=script&lang=ts&"
export * from "./edi-form.vue?vue&type=script&lang=ts&"
import style0 from "./edi-form.vue?vue&type=style&index=0&id=7a2a5f46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2a5f46",
  null
  
)

export default component.exports